<template>
	<v-avatar :color="color">
		<v-icon dark v-if="!user.profile_image">mdi-account-circle</v-icon>
		<img v-else :src="user.profile_image">
	</v-avatar>
</template>

<script type="text/javascript">	
	export default{
		name: "UserAvatar",
		props: {
			user: {type: Object },
			color: { type: String, default: () => "accent" }
		}
	}
</script>